export default "__VITE_ASSET__CkK1vc1P__"